import { render, staticRenderFns } from "./MAM_riskControlInfo.vue?vue&type=template&id=2c2bd2b3&scoped=true&"
import script from "./MAM_riskControlInfo.vue?vue&type=script&lang=js&"
export * from "./MAM_riskControlInfo.vue?vue&type=script&lang=js&"
import style0 from "./MAM_riskControlInfo.vue?vue&type=style&index=0&id=2c2bd2b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2bd2b3",
  null
  
)

export default component.exports